import styled from 'styled-components';
import { palette, theme } from 'styled-tools';

import { fontFamily, minWidth } from '@calm-web/design-system';

import chevronRightIcon from 'icons/chevron-right-centered.svg';

export const Wrapper = styled.a`
	align-items: center;
	background: rgba(0, 0, 0, 0.25);
	border-radius: 100px;
	border: none;
	cursor: pointer;
	display: flex;
	${fontFamily}
	font-size: 18px;
	height: 60px;
	padding: 0 24px;
	margin-bottom: 16px;
	position: relative;
	transition: ${theme('animation.transition')};
	width: 100%;
	text-decoration: none;

	${minWidth('desktop')} {
		&:hover {
			background: rgba(0, 0, 0, 0.1);
		}
	}
`;

export const IconWrapper = styled.div`
	align-items: center;
	border-radius: 50%;
	display: flex;
	flex: 0 0 36px;
	height: 36px;
	justify-content: center;
	position: relative;
	width: 36px;

	& svg {
		height: 24px;
		width: 24px;

		& path {
			fill: ${palette('white')};
		}
	}
`;

export const Label = styled.div`
	color: ${palette('white')};
	margin-left: 12px;
`;

export const ChevronRight = styled(chevronRightIcon)`
	position: absolute;
	opacity: 0.5;
	transform: rotate(180deg);
	height: 24px;
	right: 24px;
	width: 24px;

	& path {
		fill: ${palette('white')};
	}
`;
